/**
 * Ensure an image has at least `minSize` pixels on its longest side.
 * SVGs loaded via `new Image()` rasterize at their intrinsic dimensions
 * (often 64x64), which looks pixelated when drawn larger on canvas.
 * This re-rasterizes small images onto a bigger offscreen canvas so
 * subsequent drawImage calls sample from a crisp source.
 *
 * Returns the original image unchanged if already large enough.
 */
export const ensureMinResolution = (img, minSize = 256) => {
  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;
  if (w === 0 || h === 0) return img;
  if (w >= minSize && h >= minSize) return img;

  try {
    const scale = minSize / Math.max(w, h);
    const rw = Math.round(w * scale);
    const rh = Math.round(h * scale);
    const canvas = document.createElement('canvas');
    canvas.width = rw;
    canvas.height = rh;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, rw, rh);
    return canvas;
  } catch {
    return img;
  }
};